import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { AppRedirectService } from 'src/app/services/app-redirect.service';
import { TranslationService } from 'src/app/services/translation.service';
@Component({
  selector: 'app-race-share-error-handling',
  templateUrl: './race-share-error-handling.component.html',
  styleUrls: ['./race-share-error-handling.component.scss']
})
export class RaceShareErrorHandlingComponent {

  @Input() error_header: string = ''
  @Input() error_sub_heading_1: string = ''
  @Input() error_sub_heading_2: string = ''
  @Input() showTriggerGoToApp: boolean = false;
  showSpinner$!: Observable<boolean>;
  translationData: any[] = [];
  hasBanner = false;


  constructor(private readonly translationService: TranslationService, 
    private readonly appRedirectService: AppRedirectService) { }


  ngAfterViewInit() {
    setTimeout(() => {
      this.hasBanner = this.appRedirectService.checkBannerPresence();
    });
  }

  triggerGoToApp() {
    this.showSpinner$ = this.appRedirectService.showSpinner$;
    setTimeout(() => {
      this.appRedirectService.closeSpinner();
    }, 3000);
    this.appRedirectService.triggerGoToApp();

  }




}
